import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import {
    InputLabel,
    FormControl,
    OutlinedInput,
    Button,
} from "@mui/material";
import Loader from "../../components/Loader";
import withToast from "../../hocs/withToast";
import { getCareTeamUserList, saveCareTeamUser, updateCareTeamUser } from '../../redux/reducers/careTeamReducer';

const CareTeamForm = ({ modalClose, notify }) => {
    const dispatch = useDispatch();
    const { currentCareTeamEntity = {}, loading } = useSelector((state) => state.careTeam);

    useEffect(() => {
        setFormData({ ...currentCareTeamEntity, userCredId: currentCareTeamEntity?.careUserId });
    }, [currentCareTeamEntity])

    const [formData, setFormData] = useState({
        userCredId: 0,
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
    });

    const handleChange = (e) => {
        const { name, value, } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const validateForm = (formData) => {
        if (!formData.firstName)
            return 'First Name is Required'
        if (!formData.lastName)
            return 'Last Name is Required'
        if (!formData.email)
            return 'Email is Required'
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = validateForm(formData)
        if (errors)
            return notify(errors, "error")
        if (formData?.userCredId) {
            dispatch(updateCareTeamUser(formData))
                .unwrap()
                .then(res => {
                    notify(res.message, "success");
                    dispatch(getCareTeamUserList());
                    modalClose();
                })
                .catch((err) => {
                    notify(err.message, "error");
                });
        }
        else {
            dispatch(saveCareTeamUser(formData))
                .unwrap()
                .then(res => {
                    notify(res.message, "success");
                    dispatch(getCareTeamUserList());
                    modalClose();
                })
                .catch((err) => {
                    notify(err.message, "error");
                });
        }
    };

    return (
        <form onSubmit={handleSubmit} className="d-flex flex-column align-items-center">
            <div className="d-flex w-100">
                <FormControl variant="outlined" className="mb-3 w-50">
                    <InputLabel htmlFor="outlined-adornment-name">First Name</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-firstName"
                        type="text"
                        name="firstName"
                        value={formData?.firstName}
                        onChange={handleChange}
                        label="First Name"
                        required
                    />
                </FormControl>

                <FormControl variant="outlined" className="mb-3 w-50">
                    <InputLabel htmlFor="outlined-adornment-name">Last Name</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-lastName"
                        type="text"
                        name="lastName"
                        value={formData?.lastName}
                        onChange={handleChange}
                        label="Last Name"
                        required
                    />
                </FormControl>
            </div>

            <FormControl variant="outlined" className="mb-3 w-100">
                <InputLabel htmlFor="outlined-adornment-email">Email</InputLabel>
                <OutlinedInput
                    id="outlined-adornment-email"
                    type="email"
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                    label="Email"
                    disabled={formData?.id}
                    required
                />
            </FormControl>

            <FormControl variant="outlined" className="mb-3 w-100">
                <InputLabel htmlFor="outlined-adornment-phone">Phone</InputLabel>
                <OutlinedInput
                    id="outlined-adornment-phone"
                    type="tel"
                    name="phone"
                    value={formData?.phone}
                    onChange={handleChange}
                    label="Phone"
                />
            </FormControl>

            <div className="mt-2 text-center">
                <Button
                    variant="contained"
                    sx={{ borderRadius: "20px", backgroundColor: "#000", color: "#fff" }}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
                <Button
                    variant="outlined"
                    sx={{ borderRadius: "20px", color: "#000", borderColor: "#000", marginLeft: 10 }}
                    onClick={modalClose}
                >
                    Cancel
                </Button>
            </div>
            <Loader loading={loading} />
        </form>
    );
};

export default withToast(CareTeamForm);